import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function postClessonFinish(clessonId: any) {
    const { apiPostClessonFinish } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostClessonFinish}${clessonId}/`);
}
